<div class="page_title">
    <div class="container-fluid"> 
    <div class="row">
        <div class="col-auto" *ngIf="this.claimId">
            <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()" >
            </k-button> 
        </div>
        <div class="col">
            <h3>{{this.currentFormType}} Claim</h3>
            <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
        </div>
    </div>
</div>
</div>
<div class="container-fluid">
    <div class="pages_space">
        <div class="row wizard-container">
            <ng-container *ngIf="wizardData">
                <k-wizard class="claim_form" [data]="wizardData" [wizardId]="wizardId" [options]="wizardOptions"
                    (actionEvent)="handleAction($event)" [isSaving]="false"></k-wizard>
            </ng-container>
        </div>
        <k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
            [timeout]="timeout"></k-simple-alert>
        <k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText"
  [timeout]="timeout"></k-simple-alert>
    </div>
</div>